import { MessageCircle, Check } from "lucide-react";
import LeadForm from "@/components/marketing/LeadForm";
import { waLink, track } from "@/lib/api";
import { useSEO, breadcrumbSchema } from "@/lib/seo";

export default function Demo() {
  useSEO({
    title: "Book a Free Demo — Mashara Finance Business Management Software",
    description: "Book a personalized 30-minute demo of Mashara Finance. See Finance, HR, Attendance, Payroll, Expenses and Invoices working for your organization.",
    path: "/demo",
    jsonLd: breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Book a Demo", path: "/demo" }]),
  });

  return (
    <div data-testid="demo-page" className="py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-start">
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-emerald-700 mb-3">Book a Demo</p>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900" data-testid="demo-headline">
            See Mashara Finance Working for Your Organization
          </h1>
          <p className="mt-4 text-base sm:text-lg text-slate-600">
            A 30-minute personalized walkthrough of the modules that matter to you — Finance, HR, Attendance, Payroll, Expenses, Invoices and Reports.
          </p>
          <div className="mt-8 space-y-3">
            {["Personalized to your organization type", "See your exact workflows mapped", "Pricing guidance for your team size", "No obligation — just clarity"].map((p) => (
              <div key={p} className="flex items-center gap-2.5 text-slate-700">
                <Check className="w-5 h-5 text-emerald-600 shrink-0" /> {p}
              </div>
            ))}
          </div>
          <div className="mt-8 rounded-2xl bg-slate-50 border border-slate-200 p-6">
            <p className="font-semibold text-slate-900 text-sm mb-3">Prefer WhatsApp?</p>
            <a href={waLink("Hello, I would like to book a Mashara Finance demo.")} target="_blank" rel="noopener noreferrer"
              data-testid="demo-whatsapp-button" onClick={() => track("whatsapp_click", { location: "demo_page" })}
              className="inline-flex items-center gap-2 rounded-xl bg-[#25D366] text-white px-6 py-3 font-semibold text-sm hover:opacity-90 transition-opacity">
              <MessageCircle className="w-4 h-4" /> Chat on WhatsApp — +91 91620 55572
            </a>
          </div>
        </div>
        <LeadForm leadType="demo" title="Request Your Demo" subtitle="Fill this in and we'll schedule within one business day." />
      </div>
    </div>
  );
}
